import React, {Component, createRef } from "react"; 
import {  Select, message, Row, Col, Space} from "antd"; 
import {
  Form,
  ModalItem,
  FormItem,
  SelectItem,
  InputNumberItem,
  InputItem, 
  RangePickerItem, 
  ButtonItem, 
  SwitchItem
} from "../../../../Components/Items";import moment from "moment"; 
import axios from "axios"; 

const {Option} = Select; 

const LISTA_FRECUENCIAS = [
    { id: 'Mensual', nombre: 'Mensual' },
    { id: 'Bimestral', nombre: 'Bimestral' },
    { id: 'Trimestral', nombre: 'Trimestral' },
    { id: 'Cuatrimestral', nombre: 'Cuatrimestral' },
    { id: 'Semestral', nombre: 'Semestral' },
    { id: 'Anual', nombre: 'Anual' },
    //{ id: 'PAGO_UNICO', nombre: 'Pago Único' }
];

class ModalPolizaSeguro extends Component {
    formRef = createRef();

    state = {
        loading: false,
        objetoMonedas : [], 
        objetoFrecuencias: [],
    };
    
    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.consultarMonedas();
            this.setState({ loading: false });
            setTimeout(() => {
                if (this.props.poliza) {
                    this.setFormValues(this.props.poliza);
                } else {
                    this.formRef.current?.resetFields();
                    
                    this.formRef.current?.setFieldsValue({
                        monedaId: "60c7e4396465ad440c41c15a",
                        recordatorios: true,
                    });
                }
            }, 200);
        }
    }

    consultarMonedas = () => {
        axios.post("monedas/selectMonedas")
        .then((res) => {
            const monedas = res.data; 
            const opciones = monedas.map((value) => (
            <Option value={value._id} key={value._id}>
                {value.nombre + " - " + value.abreviacion}
            </Option>
            ));

            this.setState({ objetoMonedas: opciones });
        })
        .catch((error) => {
            console.error("Error al cargar monedas", error);
            message.error("No se pudieron cargar las monedas");
        });

        const opciones = LISTA_FRECUENCIAS.map((item) => (
            <Option key={item.id} value={item.id}>
                {item.nombre}
            </Option>
        ));
        this.setState({ objetoFrecuencias: opciones });
    };

    setFormValues = (poliza) => {
        const fechas = [
            poliza.fechaInicio ? moment(poliza.fechaInicio) : null,
            poliza.fechaFin ? moment(poliza.fechaFin) : null
        ];

        this.formRef.current.setFieldsValue({
            ...poliza,
            fechas: fechas,
            recordatorios: poliza.recordatorios !== undefined ? poliza.recordatorios : true,
        });
    };

    handleSubmit = () => {
        this.formRef.current
        .validateFields()
        .then((values) => {
            this.setState({ loading: true });

            const { poliza, empresaId } = this.props;
            const esEdicion = !!poliza;

            const payload = {
                ...values,
                empresaId: empresaId,
                fechaInicio: values.fechas ? values.fechas[0].toISOString() : null,
                fechaFin: values.fechas ? values.fechas[1].toISOString() : null,
                _id: poliza ? poliza._id : undefined,
            };

            axios.post
            (
                '/polizasSeguro/guardarPoliza', 
                payload
            )
            .then((res) => {
                if (res.data.success=== 2) {
                message.success(
                    esEdicion
                    ? "Póliza actualizada."
                    : "Póliza guardada."
                );
                this.props.onSuccess(); 
                this.props.onCancel(); 
                } else {
                message.error(res.data.message || "Error al guardar");
                }
            })
            .catch((error) => {
                console.error("Error en petición:", error);
                message.error("Ocurrió un error en el servidor.");
                this.setState({ loading: false });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
        })
        
    };

    render() {
        const { visible, onCancel, poliza } = this.props;
        const titulo = poliza ? "Editar Póliza" : "Nueva Póliza";

        return (
            <ModalItem
                title={titulo}
                visible={visible}
                onCancel={onCancel}
                confirmLoading={this.state.loading}
                width={800}
                destroyOnClose
                spinning ={this.state.loading}
            >
                <Form ref={this.formRef} layout="vertical">
                    <Row gutter={16} style={{marginTop : "10px"}}>
                        <Col span={12}>
                            <FormItem name="numero" label="No. Póliza" required>
                                <InputItem placeholder="Ej. P - 12345" />
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem name="aseguradora" label="Aseguradora" required>
                                <InputItem placeholder="Nombre aseguradora" />
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <FormItem name="descripcion" label="Descripción" required>
                                <InputItem placeholder="Descripción" />
                            </FormItem>
                        </Col>
                         <Col span={12}>
                            <FormItem
                                name="monedaId"
                                label="Moneda"
                                required
                                initialValue="60c7e4396465ad440c41c15a" 
                            >
                                <SelectItem
                                placeholder="Moneda"
                                onChange={(value) => {
                                    if (value === "60c7e4396465ad440c41c15a") {
                                    this.formRef.current.setFieldsValue({
                                        tipoDeCambio: 1,
                                    });
                                    }
                                }}
                                >
                                {this.state.objetoMonedas}
                                </SelectItem>
                            </FormItem>
                        </Col>
                    </Row> 
                    <Row gutter={16}>
                        <Col span={12}>
                            <FormItem
                                name="montoPago"
                                label="Monto x Pago"
                                tooltip="Es el monto que se debe pagar cada vez según la frecuencia seleccionada (Ej. Mensual)."
                            >
                                <InputNumberItem
                                    style={{ width: "100%" }}
                                    dinero
                                />
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem
                                name="total"
                                label="Costo Total"
                                tooltip="Es el costo total de la póliza cubriendo todo el periodo de vigencia."
                            >
                                <InputNumberItem
                                    style={{ width: "100%" }}
                                    dinero
                                />
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <FormItem
                                name="frecuenciaPago"
                                label="Frecuencia"
                            >
                                <SelectItem placeholder="Selecciona Frecuencia">
                                    {this.state.objetoFrecuencias}
                                </SelectItem>
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem name="fechas" label="Vigencia">
                                <RangePickerItem style={{ width: '100%' }} format="DD/MM/YYYY" />
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                        <FormItem
                            name="recordatorios"
                            label="Activar recordatorios"
                            tooltip="Si activas esto se enviaran recordatorios para pagar la poliza y antes de que venza."
                            valuePropName="checked" 
                        >
                            <SwitchItem 
                                checkedChildren="Activado" 
                                unCheckedChildren="Desactivado" 
                            />
                        </FormItem>
                        </Col>
                    </Row>
                    <div
                        style={{
                        display: "flex",
                        justifyContent: "flex-end", 
                        marginTop: 20,
                        marginBottom: 10,
                        }}
                    >
                        <Space>
                        <ButtonItem
                            danger
                            onClick={onCancel}
                            style={{ minWidth: 100 }}
                        >
                            Cancelar
                        </ButtonItem>
                        
                        <ButtonItem
                            type="primary"
                            onClick={this.handleSubmit} 
                            style={{ minWidth: 100 }}
                            loading={this.state.loading} 
                        >
                            Guardar
                        </ButtonItem>
                        </Space>
                    </div>
                </Form>
            </ModalItem>
        );
    }
}

export default ModalPolizaSeguro;